import React from 'react';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Profile } from '../types';

interface AddressInfoFormProps {
  profile: Profile;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddressInfoForm: React.FC<AddressInfoFormProps> = ({ profile, handleChange }) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label={t('screening_profile.street')}
          name="street"
          value={profile.street}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.house_number')}
          name="houseNumber"
          value={profile.houseNumber}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.postal_code')}
          name="postalCode"
          value={profile.postalCode}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.city')}
          name="city"
          value={profile.city}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.country')}
          name="country"
          value={profile.country}
          onChange={handleChange}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t('screening_profile.province')}
          name="province"
          value={profile.province}
          onChange={handleChange}
          required
        />
      </Grid>
    </>
  );
};

export default AddressInfoForm; 